import React, { FC, ReactNode } from 'react';
import styles from './TabletFilterSection.module.scss';

export interface FilterSectionProps {
  children: ReactNode;
  variant?: 'section' | 'field';
  className?: string;
}

export const TabletFilterSection: FC<FilterSectionProps> = ({
  children,
  variant = 'section',
  className,
}) => {
  const sectionClass = variant === 'field' ? styles.field : styles.section;

  return <div className={`${sectionClass} ${className || ''}`}>{children}</div>;
};
